import ApiProvider from './ApiProvider'
import { Source } from '../models/Source'
import Booking from '../models/Booking'
import DateService from '../services/DateService'

export class BookingRules {
    minDuration: number | null
    maxDuration: number | null
    bookingAvailable: boolean
    bookingNotes: string | null
    bookingsFrom: string | null
    bookingsUntil: string | null
    minPax: number | null
    maxPax: number | null
    noDuration: boolean
    type : string

    constructor (data: any) {
        this.minDuration = data.min_duration
        this.maxDuration = data.max_duration
        this.minPax = data.min_people
        this.maxPax = data.max_people
        this.bookingAvailable = !!data.booking_available
        this.noDuration = !!data.no_duration
        this.bookingNotes = data.booking_notes
        this.type = data.type || null
        this.bookingsFrom = data.bookings_from
        this.bookingsUntil = data.booking_until

    }

    get fixedDuration (): boolean {
        if (this.noDuration) {
            return true
        }

        if (this.minDuration && this.maxDuration) {
            return this.minDuration === this.maxDuration
        }

        return false
    }

    get shouldAskDuration (): boolean {
        return !this.fixedDuration
    }
}

export default class RulesProvider extends ApiProvider {
    booking: Booking

    constructor (booking: Booking) {
        super()
        this.booking = booking
    }

    getUrl (): string {
      return [
        this.baseUrl,
        'venues',
        this.booking.venue!.id,
        'booking-rules'
      ].join('/')
    }

    requestRules (): Promise<BookingRules> {
        const url = this.getUrl()

        const params = {
            num_people: this.booking.pax,
            date: DateService.formatDateForAPI(this.booking.date!),
            type: this.booking.type!.id
        }

        const requestUrl = url + this.objToParams(params)

        return this.get(requestUrl)
            .then((response) => {
                const payload = response.data.payload

                return new BookingRules(payload)
            })
    }

    requestMultipleRules (additionalTypes: string[]): Promise<BookingRules[]> {
      const url = this.getUrl()

      const params = {
        num_people: this.booking.pax,
        date: DateService.formatDateForAPI(this.booking.date!),
        multipleTypes: additionalTypes || []
      }

      params.multipleTypes.push(this.booking.type!.id)

      const requestUrl = url + this.objToParams(params)

      return this.get(requestUrl)
        .then((response) => {
          let rulesForTypes: BookingRules[] = []
          const payload = response.data.payload

          payload.forEach((ruleData: any) => {
            rulesForTypes.push(new BookingRules(ruleData))
          })

          return rulesForTypes
        })
    }

}



// WEBPACK FOOTER //
// ./src/services/RulesProvider.ts